<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <div>
          <a href="https://academy.aifc.kz/cron/10" target="_blank" style="margin-right: 10px;"><n-button>Запустить синхронизацию</n-button></a>
          <n-button @click="$router.push({name: 'courses.create'})">Добавить курс</n-button>
        </div>
      </n-divide>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #image="{item}">
          <n-image centered :src="item.avatar" />
        </template>
        <template #content="{item}">
          <div v-html="item.content" />
        </template>
        <template #createdAt="{item}">
          {{ $app.date.format(item.createdAt) }}
        </template>
        <template #isActive="{item}">
          <div v-if="item.isFailed" style="color: var(--danger)">Не&nbsp;загрузился</div>
          <div v-else-if="item.isActive" style="color: var(--success)">Активный</div>
          <div v-else>Не отображается</div>
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'courses.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'image', title: 'Изображение', },
      { name: 'title', title: 'Название', },
      { name: 'content', title: 'Описание', },
      { name: 'isActive', title: 'Статус', },
      { name: 'createdAt', title: 'Дата создания', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadProjects()
  },
  methods: {
    loadProjects() {
      this.$var('load', true)
      $api.app.courses.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 150px;
    --n-image-height: 150px;
  }
</style>
